module.exports = __webpack_public_path__ + "static/media/athletic-football-running-to-catch-svgrepo-com.abe7d30c.svg";